export enum SmsCodeType {
  Register = 1, // 注册验证码
  FindPassword = 2, // 找回密码验证码
  Logout = 3, // 注销验证码
  Login = 4, // 手机号验证码登录
}

// 发送验证码请求
export interface IReqSendSms {
  Phone: string
  AreaCode: string
  TypeId: SmsCodeType
}

// 登录请求
export interface IReqLogin {
  Phone: string
  VerifyCode: string
  AreaCode: string
}

// 登录响应
export interface IResLogin {
  Token: string
  Id: number
  Nick: string
  Email: string | null
  Phone: string
  RoleId: number
}

// 注册请求
export interface IReqRegister {
  Phone: string
  VerifyCode: string
  AreaCode: string
}

// 用户信息响应
export interface IResUserInfo {
  id: string
  nickname: string
  avatar: string
  phone: string
}
